// extracted by mini-css-extract-plugin
export default {"button":"HelpCenterButton_button__HF2Xk","badgeAnchor":"HelpCenterButton_badgeAnchor__hTcwf","iconWrapper":"HelpCenterButton_iconWrapper__eDm6F"};